import { parse, format } from "date-fns";
import { isoDateFormat, datePickerDisplayFormat } from "./formats";

export const yesNoMapper = val => (val ? "Ja" : "Nein");

export const optionsMapper = (val, options) => {
  const option = options.find(({ value }) => value === val);

  return option ? option.label : "";
};

export const dateMapper = val =>
  format(parse(val, isoDateFormat, new Date()), datePickerDisplayFormat);

export const formatCurrency = value =>
  Number(value).toLocaleString("de-DE", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
